import Box from "@material-ui/core/Box"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardContent from "@material-ui/core/CardContent"
import Button from "@material-ui/core/Button"
import { Link } from "react-router-dom"
import { useUrlWithContext } from "../../../hooks/use-url-with-context"
import { paths } from "../../../paths"
import { HourReportWorkflow } from "../../api"
import { useAdminInfoDescription } from "../hour-reporting-admins/hooks/use-translations"
import { MaterialSymbol } from "../hour-reporting-roles/components/MaterialSymbol"
import AdminOwnHoursReviewSettingCheckbox from "./AdminOwnHoursReviewSettingCheckbox"
import { useAdminOwnHoursReviewTranslations } from "./use-translations"

type AdminOwnHoursReviewSettingsProps = {
  workflow: HourReportWorkflow
}

const AdminOwnHoursReviewSettings = ({ workflow }: AdminOwnHoursReviewSettingsProps) => {
  const translations = useAdminOwnHoursReviewTranslations()
  const adminInfoDescription = useAdminInfoDescription(workflow)
  const requiresApproval = workflow === HourReportWorkflow.Approval || workflow === HourReportWorkflow.CheckAndApproval
  const { createPathWithContext } = useUrlWithContext()
  const adminsPath = createPathWithContext(`${paths.orgMembers()}?tab=hour-reporting-admins`, {
    withSubContext: false,
  })

  return (
    <Box
      mt={3}
      maxWidth={requiresApproval ? "100%" : 600}
      mx="auto"
      style={{ transition: "max-width 0.3s ease-in-out, height 0.3s ease-in-out" }}
    >
      <Card variant="outlined">
        <CardHeader
          title={translations.title}
          subheader={adminInfoDescription}
          subheaderTypographyProps={{ variant: "body2", style: { marginTop: 8 } }}
        />
        <CardContent>
          {workflow !== HourReportWorkflow.ReportingOnly && (
            <Box ml={-1}>
              <AdminOwnHoursReviewSettingCheckbox />
            </Box>
          )}
          <Box mt={workflow === HourReportWorkflow.ReportingOnly ? -1 : 2} ml={-1}>
            <Button component={Link} to={adminsPath} color="primary" endIcon={<MaterialSymbol name="arrow_outward" />}>
              {translations.viewCurrentAdminsLabel}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default AdminOwnHoursReviewSettings
